/**
@format
@flow
*/
import React from 'react';
import { NotificationBanner as KrispyNotificationBanner } from '@krispy/notifications/web';
import Colors from '@ziynx/theme/colors';
import { withAppManager } from '@ziynx/components/utilities';
import type { ManagedProps } from '@ziynx/flow-types/appManager';

type Props = $ReadOnly<{|
  /**
   * If set to true, will enable animations for banner.
   */
  animated?: boolean,

  /**
   * If banner needs to have the dismiss functionality
   */
  showCloseIcon?: boolean,

  /**
   * Text for banner.
   */
  children: Node,

  /**
   * Background color of banner.
   */
  variant?: 'success' | 'error',

  /**
   * Sets how long the banner stays on screen before fading out (milliseconds).
   */
  timeout?: number,
|}>;

const BannerNotification = (props: ManagedProps<Props>): React$Node => {
  const {
    viewport,
    ...rest
  } = props;

  return (
    <KrispyNotificationBanner {...rest} viewport={viewport} colorConfig={Colors} />
  );
};

BannerNotification.defaultProps = {
  variant: 'success',
  showCloseIcon: false,
  viewport: 'desktop',
};

export default (withAppManager(BannerNotification): React$ComponentType<
  React$Config<ManagedProps<Props>, typeof BannerNotification.defaultProps>
>);
